import styled from "@emotion/styled";
import { Card, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"

type HC = {
    text?: string,
}

export const HeaderCard: React.FC<HC> = ({text}) => {
    const {t} = useTranslation();
    const CustomCard = styled(Card)({
        borderRadius: 10,
        marginBottom: "12px",
        backgroundColor: "rgb(32, 119, 190)"
      });
    
      const CustomTypography = styled(Typography)({
        margin: 8,
        borderRadius: 10,
        fontFamily: "monospace",
        letterSpacing: "0.8px",
        color: "#C5E898",
        fontWeight: "600",
        whiteSpace: "pre-line",
        backgroundColor: "#29ADB2",
        fontSize: "20px"
      });

    return (
        <CustomCard elevation={1} >
        <CustomTypography>
        { text === undefined ? t("common.imageAdvice") : text} 
        </CustomTypography>
      </CustomCard>
    )
}